<template>
  <!-- <pre v-if="responseData"> testData={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/KOLAM TAKUNGAN BANJIR.png"
        alt="KOLAM TAKUNGAN BANJIR"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>


    <div class="content-wrapper"> 
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>   
      <h2>KOLAM TAKUNGAN BANJIR PBT</h2>
      <div class="content">
        <!-- First row with only one item -->
        <div
          :style="{ background: items[0].color }"
          class="box full-width"
        >
          <p>{{ items[0].title }}</p>
          <span class="count">{{ items[0].location }}</span>
        </div>

        <!-- Second row with the remaining items -->
        <div
          v-for="item in items.slice(1)"
          :key="item.title"
          :style="{ background: item.color }"
          class="box"
        >
          <p>{{ item.title }}</p>
          <span class="count">{{ item.location }}</span>
        </div>
      </div>
    </div>


    <PrimaryModule />
    <KejuruteraanKesihatanMenu />  
  </AdminBackground>
</template>

<script setup>
import { useHttpService } from "@/httpService"
import { computed, onMounted, ref } from 'vue'

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')



const kolamTakungan = ref()

const items = computed(() => [
  { title: 'JUMLAH KESELURUHAN KOLAM TAKUNGAN BANJIR', location: kolamTakungan.value.bilangan_kolam ?? 0, color: 'linear-gradient(0deg, #7800A3 0%, #2D003D 100%)' },
  { title: 'JUMLAH KOLAM TAKUNGAN BANJIR (JENIS BASAH)', location: kolamTakungan.value.bilangan_kolam_ada_penyenggeraan, color: 'linear-gradient(0deg, #25008F 0%, #0B0029 100%)' },
  { title: 'JUMLAH KOLAM TAKUNGAN BANJIR (JENIS KERING)', location: kolamTakungan.value.bilangan_kolam_tiada_penyenggeraan, color: 'linear-gradient(0deg, #029708 0%, #013103 100%)'  },

])

const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)

async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {

    // Ensure we're working with a plain array for states
    const plainStates = toRaw(state)

    // Create query parameters for year and states
    // Create the query parameters manually
    let queryParams = `year=${year}`
    console.log('Plain states:', plainStates)

    // Check if states are "Semua Negeri" and skip appending states[] if true
    if (!plainStates.includes("Semua Negeri")) {
      // Append each state to the query string with the desired 'states[]' format
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    // Append councils[] if pbtValue is selected
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      // Append each PBT in the array to the query parameters
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    // Construct the URL with the query parameters
    const url = `kejuruteraan-kesihatan-umum/kolam-takungan-banjir?${queryParams}`

    const response = await httpGet(url)

    years.value = response.years

    // Populate states dropdown while excluding "Modified Pbt" and null values
    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils
    responseData.value = response

    var data=responseData.value.data.data

  

    kolamTakungan.value = { 
      // eslint-disable-next-line camelcase
      bilangan_kolam: data.bilangan_kolam,
      // eslint-disable-next-line camelcase
      bilangan_kolam_ada_penyenggeraan: data.bilangan_kolam_ada_penyenggeraan,
      // eslint-disable-next-line camelcase
      bilangan_kolam_tiada_penyenggeraan: data.bilangan_kolam_tiada_penyenggeraan,
    }


  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}

onMounted(() => {
  loadDataFromApi()
  
})

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state) 
watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; 
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}



.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}


.input-item {
  flex: 1;
  margin-right: 15px;
}


.input-item:last-child {
  margin-right: 0;
}



h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
}

.title-main {
  color: darkblue;
  font-size: 2rem;
  font-weight: bold;
  margin-block-end: 20;
  text-align: center;
}

.filter-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  inline-size: 100%;
  margin-block-end: 20px;
}

.filter-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.filter-box label {
  color: black;
  font-weight: bold;
  margin-block-end: 0;
}

.filter-box select {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: white;
  inline-size: auto;
}

.content {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, 1fr);
  inline-size: 100%;
}

.full-width {
  grid-column: span 2; 
}

.box {
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  block-size: 100px;
  inline-size: 100%;
  transition: transform 0.3s;
}

.box:hover {
  transform: translateY(-5px);
}

.box p,
.box .count {
  color: white;
  font-weight: bold;
  text-align: center;
}

.box p {
  font-size: 1rem;
}

.box .count {
  font-size: 2rem;
}

.my-5 {
  margin-block: 1.25rem;
  margin-inline: 0;
}

/* Styles for large screens (1024px and up) */
@media (max-width: 1024px) {
  .content-wrapper {
    padding: 15px;
    max-width: 1000px;
  }

  .input-row {
    flex-direction: column;
    gap: 10px; /* Adds spacing between fields in stacked layout */
  }

  .content {
    grid-template-columns: 1fr; /* Stacks content in a single column */
  }

  h2 {
    font-size: 1.3rem;
    text-align: center;
  }
}

/* Styles for medium screens (768px and below) */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 10px;
    max-width: 700px;
  }

  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  .content {
    grid-template-columns: 1fr; /* Stacks items in a single column */
  }

  h2 {
    font-size: 1.2rem;
    text-align: center;
  }

  .box p {
    font-size: 0.9rem; /* Smaller font size for better fit */
  }

  .box .count {
    font-size: 1.8rem;
  }
}

/* Styles for small screens (480px and below) */
@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
    max-width: 100%;
  }

  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .box {
    height: auto;
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  h2 {
    font-size: 1rem;
    text-align: center;
  }

  .box p {
    font-size: 0.8rem;
  }

  .box .count {
    font-size: 1.6rem;
  }
}
</style>
